export default "__VITE_ASSET__c5f76110__"